import { Pipe, PipeTransform } from '@angular/core';

import { SortDirection } from './models/sorting.model';

@Pipe({
    name: 'sortArrow',
})
export class HistorySortArrow implements PipeTransform {
    transform(type: SortDirection): any {
        const d: string = '';

        switch (type) {
            case SortDirection.ASC:
                return 'chevron-up';
            case SortDirection.DESC:
                return 'chevron-down';
            case null:
                return 'unfold-more-horizontal';
        }

        return d;
    }
}
